$(document).ready(function () {
  /*
   * Convert the tables into accordian for cost and comparision module
   *
   */
  var maxMobileSize = 768;
  var mobileAccordionTableSelector = ".tab-title-row.mobile-accordion";
  var previousOrientation = window.orientation;

  var checkOrientation = function () {
    if (window.orientation !== previousOrientation) {
      previousOrientation = window.orientation;
      checkScreenSize();
    }
  };

  var checkScreenSize = function () {
    var width = $(window).width();
    if (width < maxMobileSize) {
      handleMobile();
    } else {
      handleDesktop();
    }
  };

  window.addEventListener("resize", checkScreenSize, false);
  window.addEventListener("orientationchange", checkOrientation, false);
  setInterval(checkOrientation, 2000);

  function handleMobile() {
    slideUpAllInactive();
  }

  function handleDesktop() {
    showRows();
  }

  function showRows() {
    $(mobileAccordionTableSelector + " .tab-tr").each(function () {
      $(this).removeAttr("style");
    });
  }

  function slideUpAllInactive() {
    $(".tab-title-row .rh")
      .not(".active")
      .each(function () {
        $(this).next().slideUp();
      });
  }

  function handleMobileAccordionTableClick(rowHeader) {
    var table = $(rowHeader).parents(".tab-title-row");
    $(table)
      .find(".rh")
      .each(function () {
        $(this).removeClass("active");
      });
    slideUpAllInactive();

    var nextRow = $(rowHeader).next();
    if (!nextRow.is(":visible")) {
      $(rowHeader).addClass("active");
      nextRow.slideDown();
    }
  }

  $(mobileAccordionTableSelector + " .rh").click(function () {
    handleMobileAccordionTableClick(this);
  });

  checkScreenSize();
  /** cost and comparision table to accordian on mobile script ends here **/

  /*
   * Add country code automatically to phone input on country selection in country select box
   *
   */

  function toggleTelCode(elem) {
    let ctrCode = elem.getAttribute("data-country-code");
    let telList = document.querySelectorAll(".intl-tel-input .country-list li");
    telList.forEach((list) => {
      list.classList.remove("active", "highlight");
    });
    let selectedTel = document.querySelector(
      '.intl-tel-input .country-list li[data-country-code="' + ctrCode + '"]'
    );
    if (selectedTel) {
      selectedTel.classList.add("active", "highlight");
      let telCode = selectedTel.getAttribute("data-dial-code");
      document.getElementById("contact-phone").value = "+" + telCode;
    }
  }

  const countrySelect = document.querySelectorAll(
    ".country-select .country-list .country"
  );
  if (countrySelect) {
    countrySelect.forEach(function (country) {
      country.addEventListener("click", function () {
        const elem = this;
        console.log("Country click detected:", elem.value);
        toggleTelCode(elem);
      });
      country.addEventListener("touchstart", function () {
        const elem = this;
        toggleTelCode(elem);
      });
      // Listen for input event (when user types)
      country.addEventListener("input", function () {
          const elem = this;
          console.log("Country input detected:", elem.value);
          toggleTelCode(elem);
      });

      // Listen for keydown event (to detect Enter key)
      country.addEventListener("keydown", function (event) {
          if (event.key === "Enter") { // Check if the Enter key is pressed
              const elem = this;
              console.log("Enter key pressed:", elem.value);
              toggleTelCode(elem);
          }
      });
      country.addEventListener("touchstart", function () {
        console.log("Country touch detected");
        toggleTelCode(this);
      });
      
    });
  }

  $(".modal-trigger").on("click", function (e) {
    e.preventDefault();
    const loader_wrapper = document.createElement("div");
    loader_wrapper.className = "loader-wrapper";
    loader_wrapper.innerHTML = '<div class="loader"></div>'; // Corrected line
    document.body.appendChild(loader_wrapper); // Corrected line
    var modalData = $(this).data("modal-data");
    $.ajax({
      url: admin_ajax_object.ajax_url,
      type: "POST",
      data: {
        action: "get_modal_content",
        modal_data: modalData,
      },
      success: function (response) {
        console.log(response);
        $(loader_wrapper).remove();
        $("#dynamicModal .modal-body").html(response);
        const packageModal = new bootstrap.Modal("#dynamicModal");
        packageModal.show();
      },
    });
  });

  $(".modal-trigger-center").on("click", function (e) {
    e.preventDefault();
    const loader_wrapper = document.createElement("div");
    loader_wrapper.className = "loader-wrapper";
    loader_wrapper.innerHTML = '<div class="loader"></div>'; // Corrected line
    document.body.appendChild(loader_wrapper); // Corrected lin
    var modalData = $(this).data("modal-data");
    $.ajax({
      url: admin_ajax_object.ajax_url,
      type: "POST",
      data: {
        action: "get_modal_content_center",
        modal_data: modalData,
      },
      success: function (response) {
        // Parse the JSON response
        var data = JSON.parse(response);

        // Check if the response contains an error
        if (data.error) {
          console.error("Error:", data.error);
          return;
        }

        // Access the title and content from the response
        var title = data.title;
        var content = data.content;

        $(loader_wrapper).remove();
        $("#dynamicModal").addClass("center-modal");
        $("#dynamicModal .modal-title").text(title); // Set the modal title
        $("#dynamicModal .modal-body").html(content); // Set the modal content
        const packageModal = new bootstrap.Modal("#dynamicModal");
        packageModal.show();
        // $("#dynamicModal").addEventListener("hidden.bs.modal", (event) => {
        //   $("#dynamicModal").removeClass("center-modal");
        // });
      },
    });
  });

  // Get the modal
  var myModal = document.getElementById("dynamicModal");

  // Execute this code when the modal is closed
  myModal.addEventListener("hidden.bs.modal", function (event) {
    // Your JavaScript code to execute after the modal is closed
   $("#dynamicModal").removeClass("center-modal");
  });
});

/*
 * Mega menu triggers on hover instead of click
 * overriding the default click functionality of bootstrap tabs in megamenu
 * it gets triggered on hover instead of click
 */
const triggerTabList = [].slice.call(
  document.querySelectorAll(".mega-menu .nav .nav-link")
);
triggerTabList.forEach(function (triggerEl) {
  const tabTrigger = new bootstrap.Tab(triggerEl);
  triggerEl.addEventListener("mouseover", function (event) {
    event.preventDefault();
    tabTrigger.show();
  });
});

/*
 * Toggle submenu visibility
 *
 */
const getNextSibling = function (elem, selector) {
  let sibling = elem.nextElementSibling;
  if (!selector) return sibling;
  while (sibling) {
    if (sibling.matches(selector)) return sibling;
    sibling = sibling.nextElementSibling;
  }
};

const caretList = document.querySelectorAll(".menu-item-has-children .caret");
const isBelowPotrait = window.matchMedia("(max-width: 991px)");
isBelowPotrait.addEventListener("change", sidebarToggler);

function sidebarToggler(e) {
  if (e.matches) {
    caretList.forEach((caret) => {
      caret.addEventListener("click", function () {
        this.parentElement.classList.toggle("is-open");
        const currentSubmenu = getNextSibling(caret, ".sub-menu");
        currentSubmenu.classList.toggle("show");
      });
    });
  }
}

// Run it initially
sidebarToggler(isBelowPotrait);

const translator = document.getElementById("gtranslate_wrapper");
const translatorTrigger = document.querySelector(
  "#gtranslate_wrapper .selected > a"
);
const translatorOptions = document.querySelector(
  "#gtranslate_wrapper .switcher .option"
);

if (translator) {
  document.addEventListener(
    "click",
    function () {
      translator.classList.remove("open");
      translatorTrigger.classList.remove("open");
    },
    false
  );

  translator.addEventListener(
    "click",
    function (e) {
      this.classList.toggle("open");
      translatorTrigger.classList.toggle("open");
      e.stopPropagation();
    },
    false
  );
}
